import { render, staticRenderFns } from "./JobActionsMenu.vue?vue&type=template&id=5641e0c7"
import script from "./JobActionsMenu.vue?vue&type=script&lang=js"
export * from "./JobActionsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports